import { render, staticRenderFns } from "./AdminChangePasswordFormModal.vue?vue&type=template&id=9d098080"
import script from "./AdminChangePasswordFormModal.vue?vue&type=script&lang=js"
export * from "./AdminChangePasswordFormModal.vue?vue&type=script&lang=js"
import style0 from "./AdminChangePasswordFormModal.vue?vue&type=style&index=0&id=9d098080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports